import { decryptUserData, encryptUserData } from '~utils/encryption';

const useLocalStorage = () => {
  const appName = 'meditrack_app_ts';

  const userData =
    (decryptUserData(
      localStorage.getItem(appName)!
    ) as Partial<UserCredentials>) ?? {};

  const recaptcha = localStorage.getItem('recaptcha') ?? '';

  const setRecaptcha = (token: string) => {
    localStorage.setItem('recaptcha', token);
  };

  const removeRecaptcha = () => localStorage.removeItem('recaptcha');

  const updateUserData = (newUserData = {}) => {
    const prevUserData = decryptUserData(localStorage.getItem(appName)!) ?? {};
    const updatedUserData = { ...prevUserData, ...newUserData };
    localStorage.setItem(appName, encryptUserData(updatedUserData));
  };

  const removeUserData = () => {
    localStorage.removeItem(appName);
  };

  return {
    appName,
    recaptcha,
    userData,
    updateUserData,
    removeUserData,
    setRecaptcha,
    removeRecaptcha
  };
};

export default useLocalStorage;
